import React, { PropsWithChildren, useState } from 'react';
import { Box, Stack, Typography, IconButton } from '@mui/material';
import { KeyboardArrowUp, KeyboardArrowDown } from '@mui/icons-material';

interface Props {
  label?: string;
}

export const FilterCardContainer = ({ label, children }: PropsWithChildren<Props>) => {
  const [isOpen, setIsOpen] = useState<boolean>(true);

  return (
    <Box
      sx={{
        padding: '1rem',
        margin: '0 0.5rem',
        borderRadius: '0.5rem',
        boxShadow: ({ shadows }) => shadows[1],
        backgroundColor: ({ palette }) => palette.background.paper,
      }}
    >
      <Stack gap="0.5rem">
        <Stack direction="row" alignItems="center" justifyContent="space-between">
          {label && (
            <Typography variant="subtitle2" component="span">
              {label}
            </Typography>
          )}

          <IconButton sx={{ justifySelf: 'flex-end' }} size="small" onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? <KeyboardArrowUp fontSize="small" /> : <KeyboardArrowDown fontSize="small" />}
          </IconButton>
        </Stack>

        {isOpen && children}
      </Stack>
    </Box>
  );
};
